
let forgotpasswordStep1 ={
  email: null,
  phone: null,
  message: null,
}
export default {
  namespaced: true,
  state: {
    forgotpasswordStep1
  },
  mutations: {
 
    setForgotpasswordStep1(state, payload) {
      state.forgotpasswordStep1 = {
        email: payload.email,
        phone: payload.phone,
        message: payload.message,
      };
    },
  },
  actions: {}
}
